import type { TransferRepository } from '@/core/transfer'
import type { UseCase } from '@/core/shared'

export const rejectTransfer: UseCase<TransferRepository, 'rejectTransfer'> = repository => {
  return async (token) => {
    return await repository.rejectTransfer(token)
  }
}
